import React from "react";

interface SecondaryEmailInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}
import { useEffect, useState } from "react";
import { userApi } from "@/components/admin/users/api/userApi";

export default function SecondaryEmailInput({ value, onChange, ...props }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    userApi.fetchEmails().then(setOptions);
  }, []);

  return (
    <div>
      <input
        type="email"
        className="input input-bordered w-full"
        list="secondary-email-list"
        value={value}
        onChange={e => onChange(e.target.value)}
        {...props}
      />
      <datalist id="secondary-email-list">
        {options.map(opt => (
          <option value={opt.value} key={opt.value}>{opt.label}</option>
        ))}
      </datalist>
    </div>
  );
}
